import React from 'react';
import PageNavOverlay from 'src/components/PageNavOverlay';

export default {
  getPageNavOverlay: () => <PageNavOverlay dataElement="customPageNavOverlay"/>,
};